import React from 'react';
/*
    types - default=date,datetime-local,month,time,week
*
*/
const DatePicker = ({ type = 'date' }) => {
    return React.createElement("input", { type: type });
};
if (process.env.NODE_ENV !== 'production') {
    DatePicker.displayName = 'DatePicker';
}
export default DatePicker;
//# sourceMappingURL=index.js.map